export default __webpack_public_path__ + "static/video-placeholder-cd1447b5e271aa464152b1adda3ed617.png";